export enum WebviewPages {
  BackgroundCheckLinker = 'background-check-linker',
  DropshippingStatus = 'dropshipping-status',
  PhoneVerification = 'phone-verification',
  MailingAddress = 'mailing-address',
  RedCardEntry = 'red-card-entry',
  ActivationKitSplash = 'activation-kit-splash',
  FastPaySetup = 'fast-pay-setup',
  InAppEducation = 'in-app-education',
  InAppEducationV4 = 'in-app-education-v4',
  InstantDashSplash = 'instant-dash-splash',
  VehicleInfoEntry = 'vehicle-info-entry',
  ErrorPage = 'error-page',
}
